// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Card,
//   Col,
//   Container,
//   Row,
//   Modal,
//   Form,
//   Alert,
//   Badge,
// } from "react-bootstrap";
// import BreadCrumb from "Common/BreadCrumb";
// import { createAbout, getAllAbouts, updateAbout, deleteAbout } from "api/apis";
// import {
//   createBlog,
//   getAllBlogs,
//   getBlogById,
//   updateBlog,
//   deleteBlog,
// } from "api/apis";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// interface About {
//   _id: string;
//   title: string;
//   description: string;
//   mission?: string;
//   vision?: string;
//   imageUrls?: string[];
//   imageKeys?: string[];
//   updatedAt?: string;
// }

// interface Blog {
//   _id: string;
//   title: string;
//   content: string;
//   imageUrls: string[];
//   imageKeys: string[];
//   author: string;
//   tags: string[];
//   createdAt: string;
// }

// const AboutBlog = () => {
//   document.title = "About Us";

//   // About section state (keep your existing state)
//   const [about, setAbout] = useState<About | null>(null);
//   const [showAboutModal, setShowAboutModal] = useState(false);
//   const [showDeleteAboutModal, setShowDeleteAboutModal] = useState(false);
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [mission, setMission] = useState("");
//   const [vision, setVision] = useState("");
//   const [images, setImages] = useState<File[]>([]);
//   const [previewImages, setPreviewImages] = useState<string[]>([]);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);
//   const [success, setSuccess] = useState<string | null>(null);

//   // Blog section state
//   const [blogs, setBlogs] = useState<Blog[]>([]);
//   const [selectedBlog, setSelectedBlog] = useState<Blog | null>(null);
//   const [showBlogModal, setShowBlogModal] = useState(false);
//   const [showDeleteBlogModal, setShowDeleteBlogModal] = useState(false);
//   const [blogTitle, setBlogTitle] = useState("");
//   const [blogContent, setBlogContent] = useState("");
//   const [blogTags, setBlogTags] = useState("");
//   const [blogImages, setBlogImages] = useState<File[]>([]);
//   const [blogPreviewImages, setBlogPreviewImages] = useState<string[]>([]);

//   const modules = {
//     toolbar: [
//       [{ header: [1, 2, 3, 4, 5, 6, false] }],
//       ["bold", "italic", "underline", "strike"],
//       [{ color: [] }, { background: [] }],
//       [{ list: "ordered" }, { list: "bullet" }],
//       ["link", "image"],
//       ["clean"],
//     ],
//   };

//   const formats = [
//     "header",
//     "bold",
//     "italic",
//     "underline",
//     "strike",
//     "color",
//     "background",
//     "list",
//     "bullet",
//     "link",
//     "image",
//   ];

//   const fetchAbout = async () => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       const response = await getAllAbouts();
//       if (Array.isArray(response)) {
//         setAbout(response[0] || null);
//       } else {
//         setAbout(response || null);
//       }
//     } catch (error) {
//       console.error("Failed to fetch about section:", error);
//       setError("Failed to load about section");
//       setAbout(null);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (e.target.files) {
//       const files = Array.from(e.target.files);
//       setImages(files);

//       // Create previews
//       const previews: string[] = [];
//       files.forEach((file) => {
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           previews.push(reader.result as string);
//           if (previews.length === files.length) {
//             setPreviewImages(previews);
//           }
//         };
//         reader.readAsDataURL(file);
//       });
//     }
//   };

//   const handleAddOrUpdateAbout = async () => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       setSuccess(null);

//       // Validate required fields
//       if (!title || !description) {
//         setError("Title and description are required");
//         setIsLoading(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("title", title);
//       formData.append("description", description);
//       formData.append("mission", mission);
//       formData.append("vision", vision);

//       // Append each image file with proper field name
//       images.forEach((image, index) => {
//         formData.append(`images`, image); // Note: same field name for all images
//       });

//       if (isEditMode && about?._id) {
//         // For edit mode, include existing image keys
//         if (about.imageKeys) {
//           about.imageKeys.forEach((key) => {
//             formData.append("existingImageKeys", key);
//           });
//         }
//         await updateAbout(about._id, formData);
//         setSuccess("About section updated successfully");
//       } else {
//         // For create mode
//         await createAbout(formData);
//         setSuccess("About section created successfully");
//       }

//       await fetchAbout();
//       setShowAboutModal(false);
//       resetForm();
//     } catch (error: any) {
//       console.error("Failed to save about section:", error);
//       setError(error.response?.data?.message || "Failed to save about section");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleDeleteAbout = async () => {
//     try {
//       if (!about?._id) return;

//       setIsLoading(true);
//       setError(null);
//       await deleteAbout(about._id);
//       setSuccess("About section deleted successfully");
//       setAbout(null);
//       setShowDeleteAboutModal(false);
//     } catch (error) {
//       console.error("Failed to delete about section:", error);
//       setError("Failed to delete about section");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const resetForm = () => {
//     setTitle("");
//     setDescription("");
//     setMission("");
//     setVision("");
//     setImages([]);
//     setPreviewImages([]);
//     setIsEditMode(false);
//   };

//   const fetchBlogs = async () => {
//     try {
//       setIsLoading(true);
//       const response = await getAllBlogs();
//       setBlogs(response);
//     } catch (error) {
//       console.error("Failed to fetch blogs:", error);
//       setError("Failed to load blogs");
//       setBlogs([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Handle edit click for about section
//   const handleEditClick = () => {
//     if (about) {
//       setTitle(about.title);
//       setDescription(about.description);
//       setMission(about.mission || "");
//       setVision(about.vision || "");
//       setPreviewImages([]);
//       setIsEditMode(true);
//       setShowAboutModal(true);
//     }
//   };

//   // Handle image change for blog section
//   const handleBlogImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (e.target.files) {
//       const files = Array.from(e.target.files);
//       setBlogImages(files);

//       const previews: string[] = [];
//       files.forEach((file) => {
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           previews.push(reader.result as string);
//           if (previews.length === files.length) {
//             setBlogPreviewImages(previews);
//           }
//         };
//         reader.readAsDataURL(file);
//       });
//     }
//   };

//   // Blog CRUD operations
//   const handleAddOrUpdateBlog = async () => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       setSuccess(null);

//       if (!blogTitle || !blogContent) {
//         setError("Title and content are required");
//         setIsLoading(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("title", blogTitle);
//       formData.append("content", blogContent);
//       formData.append("author", "Admin");
//       formData.append("tags", blogTags);

//       blogImages.forEach((image) => {
//         formData.append("images", image);
//       });

//       if (selectedBlog?._id) {
//         // Update existing blog
//         if (selectedBlog.imageKeys) {
//           selectedBlog.imageKeys.forEach((key) => {
//             formData.append("existingImageKeys", key);
//           });
//         }
//         await updateBlog(selectedBlog._id, formData);
//         setSuccess("Blog updated successfully");
//       } else {
//         // Create new blog
//         await createBlog(formData);
//         setSuccess("Blog created successfully");
//       }

//       await fetchBlogs();
//       setShowBlogModal(false);
//       resetBlogForm();
//     } catch (error: any) {
//       console.error("Failed to save blog:", error);
//       setError(error.response?.data?.message || "Failed to save blog");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleDeleteBlog = async () => {
//     try {
//       if (!selectedBlog?._id) return;

//       setIsLoading(true);
//       setError(null);
//       await deleteBlog(selectedBlog._id);
//       setSuccess("Blog deleted successfully");
//       setShowDeleteBlogModal(false);
//       setSelectedBlog(null);
//       await fetchBlogs();
//     } catch (error) {
//       console.error("Failed to delete blog:", error);
//       setError("Failed to delete blog");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleViewBlog = async (id: string) => {
//     try {
//       setIsLoading(true);
//       const blog = await getBlogById(id);
//       setSelectedBlog(blog);
//     } catch (error) {
//       console.error("Failed to fetch blog:", error);
//       setError("Failed to load blog details");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleEditBlog = (blog: Blog) => {
//     setSelectedBlog(blog);
//     setBlogTitle(blog.title);
//     setBlogContent(blog.content);
//     setBlogTags(blog.tags.join(", "));
//     setBlogPreviewImages([]);
//     setShowBlogModal(true);
//   };

//   // Form resets
//   const resetBlogForm = () => {
//     setBlogTitle("");
//     setBlogContent("");
//     setBlogTags("");
//     setBlogImages([]);
//     setBlogPreviewImages([]);
//     setSelectedBlog(null);
//   };

//   // Initialize data
//   useEffect(() => {
//     fetchAbout();
//     fetchBlogs();
//   }, []);

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid>
//           <BreadCrumb title="About" pageTitle="Settings" />

//           {/* Success/Error Alerts */}
//           {error && (
//             <Alert variant="danger" onClose={() => setError(null)} dismissible>
//               {error}
//             </Alert>
//           )}
//           {success && (
//             <Alert
//               variant="success"
//               onClose={() => setSuccess(null)}
//               dismissible
//             >
//               {success}
//             </Alert>
//           )}

//           <Row>
//             <Col lg={12}>
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h5 className="mb-0">About Section</h5>
//                 <div>
//                   {about && (
//                     <Button
//                       variant="danger"
//                       onClick={() => setShowDeleteAboutModal(true)}
//                       className="me-2"
//                       disabled={isLoading}
//                     >
//                       Delete
//                     </Button>
//                   )}
//                   <Button
//                     variant={about ? "primary" : "success"}
//                     onClick={
//                       about ? handleEditClick : () => setShowAboutModal(true)
//                     }
//                     disabled={isLoading}
//                   >
//                     {about ? "Edit About" : "Add About"}
//                   </Button>
//                 </div>
//               </div>

//               <Card className="mb-4">
//                 <Card.Body>
//                   {isLoading && !about ? (
//                     <div className="text-center py-4">
//                       <div
//                         className="spinner-border text-primary"
//                         role="status"
//                       >
//                         <span className="sr-only">Loading...</span>
//                       </div>
//                     </div>
//                   ) : about ? (
//                     <div>
//                       <div className="mb-4">
//                         <h5>{about.title}</h5>
//                         <p className="text-muted">
//                           Last updated:{" "}
//                           {new Date(about.updatedAt || "").toLocaleString()}
//                         </p>
//                         <p>{about.description}</p>
//                         {about.mission && (
//                           <div className="mb-3">
//                             <h6>Mission</h6>
//                             <p>{about.mission}</p>
//                           </div>
//                         )}
//                         {about.vision && (
//                           <div className="mb-3">
//                             <h6>Vision</h6>
//                             <p>{about.vision}</p>
//                           </div>
//                         )}
//                       </div>
//                       {about.imageUrls && about.imageUrls.length > 0 && (
//                         <div>
//                           <h6>Images</h6>
//                           <div className="d-flex flex-wrap gap-3">
//                             {about.imageUrls.map((url, index) => (
//                               <div key={index} className="position-relative">
//                                 <img
//                                   src={url}
//                                   alt={`About ${index + 1}`}
//                                   style={{
//                                     width: "150px",
//                                     height: "150px",
//                                     objectFit: "cover",
//                                     borderRadius: "4px",
//                                   }}
//                                 />
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   ) : (
//                     <div className="text-center py-4">
//                       <p>
//                         No about section found. Click "Add About" to create one.
//                       </p>
//                     </div>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           <Row>
//             <Col lg={12}>
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h5 className="mb-0">Blog Posts</h5>
//                 <Button
//                   variant="success"
//                   onClick={() => {
//                     resetBlogForm();
//                     setShowBlogModal(true);
//                   }}
//                   disabled={isLoading}
//                 >
//                   Add Blog Post
//                 </Button>
//               </div>

//               {isLoading && blogs.length === 0 ? (
//                 <div className="text-center py-4">
//                   <div className="spinner-border text-primary" role="status">
//                     <span className="sr-only">Loading...</span>
//                   </div>
//                 </div>
//               ) : blogs.length > 0 ? (
//                 <Row>
//                   {blogs.map((blog) => (
//                     <Col key={blog._id} md={6} lg={4} className="mb-4">
//                       <Card>
//                         {blog.imageUrls?.length > 0 && (
//                           <Card.Img
//                             variant="top"
//                             src={blog.imageUrls[0]}
//                             style={{
//                               height: "200px",
//                               objectFit: "cover",
//                             }}
//                           />
//                         )}
//                         <Card.Body>
//                           <Card.Title>{blog.title}</Card.Title>
//                           <Card.Text className="text-muted small">
//                             {new Date(blog.createdAt).toLocaleDateString()} •{" "}
//                             {blog.author}
//                           </Card.Text>
//                           <Card.Text className="text-truncate">
//                             {blog.content.substring(0, 100)}...
//                           </Card.Text>
//                           <div className="d-flex justify-content-between">
//                             <Button
//                               variant="primary"
//                               size="sm"
//                               onClick={() => handleViewBlog(blog._id)}
//                             >
//                               View
//                             </Button>
//                             <div>
//                               <Button
//                                 variant="outline-primary"
//                                 size="sm"
//                                 className="me-2"
//                                 onClick={() => handleEditBlog(blog)}
//                               >
//                                 Edit
//                               </Button>
//                               <Button
//                                 variant="outline-danger"
//                                 size="sm"
//                                 onClick={() => {
//                                   setSelectedBlog(blog);
//                                   setShowDeleteBlogModal(true);
//                                 }}
//                               >
//                                 Delete
//                               </Button>
//                             </div>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     </Col>
//                   ))}
//                 </Row>
//               ) : (
//                 <Card>
//                   <Card.Body className="text-center py-4">
//                     <p>
//                       No blog posts found. Click "Add Blog Post" to create one.
//                     </p>
//                   </Card.Body>
//                 </Card>
//               )}
//             </Col>
//           </Row>
//         </Container>

//         {/* Add/Edit Modal */}
//         <Modal
//           show={showAboutModal}
//           onHide={() => setShowAboutModal(false)}
//           size="lg"
//         >
//           {" "}
//           <Modal.Header closeButton>
//             <Modal.Title>
//               {isEditMode ? "Edit About Section" : "Add About Section"}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form>
//               <Form.Group controlId="aboutTitle" className="mb-3">
//                 <Form.Label>Title*</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={title}
//                   onChange={(e) => setTitle(e.target.value)}
//                   placeholder="Enter title"
//                   required
//                 />
//               </Form.Group>
//               <Form.Group controlId="aboutDescription" className="mb-3">
//                 <Form.Label>Description*</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={3}
//                   value={description}
//                   onChange={(e) => setDescription(e.target.value)}
//                   placeholder="Enter description"
//                   required
//                 />
//               </Form.Group>
//               <Form.Group controlId="aboutMission" className="mb-3">
//                 <Form.Label>Mission</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={2}
//                   value={mission}
//                   onChange={(e) => setMission(e.target.value)}
//                   placeholder="Enter mission statement"
//                 />
//               </Form.Group>
//               <Form.Group controlId="aboutVision" className="mb-3">
//                 <Form.Label>Vision</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={2}
//                   value={vision}
//                   onChange={(e) => setVision(e.target.value)}
//                   placeholder="Enter vision statement"
//                 />
//               </Form.Group>
//               <Form.Group controlId="aboutImages" className="mb-3">
//                 <Form.Label>Images</Form.Label>
//                 <Form.Control
//                   type="file"
//                   accept="image/*"
//                   onChange={handleImageChange}
//                   multiple
//                 />
//                 <Form.Text className="text-muted">
//                   You can upload multiple images (JPEG, PNG)
//                 </Form.Text>

//                 {/* Existing images section - only shown in edit mode */}
//                 {isEditMode &&
//                   about?.imageUrls &&
//                   about.imageUrls.length > 0 && (
//                     <div className="mt-3">
//                       <h6>
//                         Existing Images{" "}
//                         <Badge bg="info">{about.imageUrls.length}</Badge>
//                       </h6>
//                       <div className="d-flex flex-wrap gap-2 mb-3">
//                         {about.imageUrls.map((url, index) => (
//                           <div
//                             key={`existing-${index}`}
//                             className="position-relative"
//                           >
//                             <img
//                               src={url}
//                               alt={`Existing ${index + 1}`}
//                               style={{
//                                 width: "80px",
//                                 height: "80px",
//                                 objectFit: "cover",
//                                 borderRadius: "4px",
//                               }}
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                 {/* New images section */}
//                 <div className="mt-3">
//                   <h6>
//                     New Images{" "}
//                     {previewImages.length > 0 && (
//                       <Badge bg="success">{previewImages.length}</Badge>
//                     )}
//                   </h6>
//                   {previewImages.length > 0 ? (
//                     <div className="d-flex flex-wrap gap-2">
//                       {previewImages.map((preview, index) => (
//                         <div key={`new-${index}`} className="position-relative">
//                           <img
//                             src={preview}
//                             alt={`Preview ${index + 1}`}
//                             style={{
//                               width: "80px",
//                               height: "80px",
//                               objectFit: "cover",
//                               borderRadius: "4px",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <div className="text-muted">
//                       {isEditMode
//                         ? "No new images added yet"
//                         : "No images selected yet"}
//                     </div>
//                   )}
//                 </div>
//               </Form.Group>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowAboutModal(false)}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={handleAddOrUpdateAbout}
//               disabled={isLoading || !title || !description}
//             >
//               {isLoading
//                 ? isEditMode
//                   ? "Updating..."
//                   : "Creating..."
//                 : isEditMode
//                 ? "Update"
//                 : "Create"}
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* Delete Confirmation Modal */}
//         <Modal
//           show={showDeleteAboutModal}
//           onHide={() => setShowDeleteAboutModal(false)}
//           centered
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>Confirm Delete</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             Are you sure you want to delete this about section? This action
//             cannot be undone.
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowDeleteAboutModal(false)}
//               disabled={isLoading}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="danger"
//               onClick={handleDeleteAbout}
//               disabled={isLoading}
//             >
//               {isLoading ? "Deleting..." : "Delete"}
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         <Modal
//           show={showBlogModal}
//           onHide={() => setShowBlogModal(false)}
//           size="lg"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               {selectedBlog ? "Edit Blog Post" : "Add Blog Post"}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form>
//               <Form.Group controlId="blogTitle" className="mb-3">
//                 <Form.Label>Title*</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={blogTitle}
//                   onChange={(e) => setBlogTitle(e.target.value)}
//                   placeholder="Enter title"
//                   required
//                 />
//               </Form.Group>
//               <Form.Group controlId="blogContent" className="mb-3">
//                 <Form.Label>Content*</Form.Label>
//                 <ReactQuill
//                   theme="snow"
//                   value={blogContent}
//                   onChange={setBlogContent}
//                   modules={modules}
//                   formats={formats}
//                   placeholder="Write your blog content here..."
//                   style={{ height: "300px", marginBottom: "50px" }}
//                 />
//               </Form.Group>
//               <Form.Group controlId="blogTags" className="mb-3">
//                 <Form.Label>Tags (comma separated)</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={blogTags}
//                   onChange={(e) => setBlogTags(e.target.value)}
//                   placeholder="tag1, tag2, tag3"
//                 />
//               </Form.Group>
//               <Form.Group controlId="blogImages" className="mb-3">
//                 <Form.Label>Images</Form.Label>
//                 <Form.Control
//                   type="file"
//                   accept="image/*"
//                   onChange={handleBlogImageChange}
//                   multiple
//                 />
//                 <Form.Text className="text-muted">
//                   You can upload multiple images (JPEG, PNG)
//                 </Form.Text>

//                 {selectedBlog?.imageUrls &&
//                   selectedBlog.imageUrls.length > 0 && (
//                     <div className="mt-3">
//                       <h6>
//                         Existing Images{" "}
//                         <Badge bg="info">{selectedBlog.imageUrls.length}</Badge>
//                       </h6>
//                       <div className="d-flex flex-wrap gap-2 mb-3">
//                         {selectedBlog.imageUrls.map((url, index) => (
//                           <div
//                             key={`existing-blog-${index}`}
//                             className="position-relative"
//                           >
//                             <img
//                               src={url}
//                               alt={`Existing ${index + 1}`}
//                               style={{
//                                 width: "80px",
//                                 height: "80px",
//                                 objectFit: "cover",
//                                 borderRadius: "4px",
//                               }}
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                 <div className="mt-3">
//                   <h6>
//                     New Images{" "}
//                     {blogPreviewImages.length > 0 && (
//                       <Badge bg="success">{blogPreviewImages.length}</Badge>
//                     )}
//                   </h6>
//                   {blogPreviewImages.length > 0 ? (
//                     <div className="d-flex flex-wrap gap-2">
//                       {blogPreviewImages.map((preview, index) => (
//                         <div
//                           key={`new-blog-${index}`}
//                           className="position-relative"
//                         >
//                           <img
//                             src={preview}
//                             alt={`Preview ${index + 1}`}
//                             style={{
//                               width: "80px",
//                               height: "80px",
//                               objectFit: "cover",
//                               borderRadius: "4px",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <div className="text-muted">
//                       {selectedBlog
//                         ? "No new images added yet"
//                         : "No images selected yet"}
//                     </div>
//                   )}
//                 </div>
//               </Form.Group>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setShowBlogModal(false)}>
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={handleAddOrUpdateBlog}
//               disabled={isLoading || !blogTitle || !blogContent}
//             >
//               {isLoading
//                 ? selectedBlog
//                   ? "Updating..."
//                   : "Creating..."
//                 : selectedBlog
//                 ? "Update"
//                 : "Create"}
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* Blog View Modal */}
//         <Modal
//           show={!!selectedBlog && !showBlogModal && !showDeleteBlogModal}
//           onHide={() => setSelectedBlog(null)}
//           size="lg"
//         >
//           {selectedBlog && (
//             <>
//               <Modal.Header closeButton>
//                 <Modal.Title>{selectedBlog.title}</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <div className="mb-3 text-muted">
//                   <small>
//                     Posted on{" "}
//                     {new Date(selectedBlog.createdAt).toLocaleDateString()} by{" "}
//                     {selectedBlog.author}
//                   </small>
//                 </div>
//                 {selectedBlog.tags.length > 0 && (
//                   <div className="mb-3">
//                     {selectedBlog.tags.map((tag, index) => (
//                       <Badge key={index} bg="secondary" className="me-2">
//                         {tag}
//                       </Badge>
//                     ))}
//                   </div>
//                 )}
//                 <div className="mb-4">
//                   <p style={{ whiteSpace: "pre-line" }}>
//                     {selectedBlog.content}
//                   </p>
//                 </div>
//                 {selectedBlog.imageUrls &&
//                   selectedBlog.imageUrls.length > 0 && (
//                     <div>
//                       <h6>Images</h6>
//                       <div className="d-flex flex-wrap gap-3">
//                         {selectedBlog.imageUrls.map((url, index) => (
//                           <div key={index} className="position-relative">
//                             <img
//                               src={url}
//                               alt={`Blog ${index + 1}`}
//                               style={{
//                                 width: "150px",
//                                 height: "150px",
//                                 objectFit: "cover",
//                                 borderRadius: "4px",
//                               }}
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//               </Modal.Body>
//               <Modal.Footer>
//                 <Button
//                   variant="secondary"
//                   onClick={() => setSelectedBlog(null)}
//                 >
//                   Close
//                 </Button>
//               </Modal.Footer>
//             </>
//           )}
//         </Modal>

//         {/* Blog Delete Confirmation Modal */}
//         <Modal
//           show={showDeleteBlogModal}
//           onHide={() => setShowDeleteBlogModal(false)}
//           centered
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>Confirm Delete</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             Are you sure you want to delete this blog post? This action cannot
//             be undone.
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowDeleteBlogModal(false)}
//               disabled={isLoading}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="danger"
//               onClick={handleDeleteBlog}
//               disabled={isLoading}
//             >
//               {isLoading ? "Deleting..." : "Delete"}
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </React.Fragment>
//   );
// };

// export default AboutBlog;
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Modal,
  Form,
  Alert,
  Badge,
} from "react-bootstrap";
import BreadCrumb from "Common/BreadCrumb";
import { createAbout, getAllAbouts, updateAbout, deleteAbout } from "api/apis";
import {
  createBlog,
  getAllBlogs,
  getBlogById,
  updateBlog,
  deleteBlog,
  getAllNews,
} from "api/apis";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface About {
  _id: string;
  title: string;
  description: string;
  mission?: string;
  vision?: string;
  imageUrls?: string[];
  imageKeys?: string[];
  updatedAt?: string;
}

interface Blog {
  _id: string;
  title: string;
  content: string;
  imageUrls: string[];
  imageKeys: string[];
  author: string;
  tags: string[];
  createdAt: string;
  type?: string;
}

const AboutBlog = () => {
  document.title = "About Us";

  // About section state
  const [about, setAbout] = useState<About | null>(null);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showDeleteAboutModal, setShowDeleteAboutModal] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [mission, setMission] = useState("");
  const [vision, setVision] = useState("");
  const [images, setImages] = useState<File[]>([]);
  const [previewImages, setPreviewImages] = useState<string[]>([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  // Blog section state
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [selectedBlog, setSelectedBlog] = useState<Blog | null>(null);
  const [showBlogModal, setShowBlogModal] = useState(false);
  const [showDeleteBlogModal, setShowDeleteBlogModal] = useState(false);
  const [blogTitle, setBlogTitle] = useState("");
  const [blogContent, setBlogContent] = useState("");
  const [blogTags, setBlogTags] = useState("");
  const [blogImages, setBlogImages] = useState<File[]>([]);
  const [blogPreviewImages, setBlogPreviewImages] = useState<string[]>([]);

  // News section state
  const [news, setNews] = useState<Blog[]>([]);
  const [selectedNews, setSelectedNews] = useState<Blog | null>(null);
  const [showNewsModal, setShowNewsModal] = useState(false);
  const [showDeleteNewsModal, setShowDeleteNewsModal] = useState(false);
  const [newsTitle, setNewsTitle] = useState("");
  const [newsContent, setNewsContent] = useState("");
  const [newsTags, setNewsTags] = useState("");
  const [newsImages, setNewsImages] = useState<File[]>([]);
  const [newsPreviewImages, setNewsPreviewImages] = useState<string[]>([]);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const fetchAbout = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await getAllAbouts();
      if (Array.isArray(response)) {
        setAbout(response[0] || null);
      } else {
        setAbout(response || null);
      }
    } catch (error) {
      console.error("Failed to fetch about section:", error);
      setError("Failed to load about section");
      setAbout(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      setImages(files);

      // Create previews
      const previews: string[] = [];
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          previews.push(reader.result as string);
          if (previews.length === files.length) {
            setPreviewImages(previews);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const handleAddOrUpdateAbout = async () => {
    try {
      setIsLoading(true);
      setError(null);
      setSuccess(null);

      // Validate required fields
      if (!title || !description) {
        setError("Title and description are required");
        setIsLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("title", title);
      formData.append("description", description);
      formData.append("mission", mission);
      formData.append("vision", vision);

      // Append each image file with proper field name
      images.forEach((image, index) => {
        formData.append(`images`, image);
      });

      if (isEditMode && about?._id) {
        // For edit mode, include existing image keys
        if (about.imageKeys) {
          about.imageKeys.forEach((key) => {
            formData.append("existingImageKeys", key);
          });
        }
        await updateAbout(about._id, formData);
        setSuccess("About section updated successfully");
      } else {
        // For create mode
        await createAbout(formData);
        setSuccess("About section created successfully");
      }

      await fetchAbout();
      setShowAboutModal(false);
      resetForm();
    } catch (error: any) {
      console.error("Failed to save about section:", error);
      setError(error.response?.data?.message || "Failed to save about section");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteAbout = async () => {
    try {
      if (!about?._id) return;

      setIsLoading(true);
      setError(null);
      await deleteAbout(about._id);
      setSuccess("About section deleted successfully");
      setAbout(null);
      setShowDeleteAboutModal(false);
    } catch (error) {
      console.error("Failed to delete about section:", error);
      setError("Failed to delete about section");
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setMission("");
    setVision("");
    setImages([]);
    setPreviewImages([]);
    setIsEditMode(false);
  };

  const fetchBlogs = async () => {
    try {
      setIsLoading(true);
      const response = await getAllBlogs();
      setBlogs(response);
    } catch (error) {
      console.error("Failed to fetch blogs:", error);
      setError("Failed to load blogs");
      setBlogs([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchNews = async () => {
    try {
      setIsLoading(true);
      const response = await getAllNews();
      setNews(response);
    } catch (error) {
      console.error("Failed to fetch news:", error);
      setError("Failed to load news");
      setNews([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle edit click for about section
  const handleEditClick = () => {
    if (about) {
      setTitle(about.title);
      setDescription(about.description);
      setMission(about.mission || "");
      setVision(about.vision || "");
      setPreviewImages([]);
      setIsEditMode(true);
      setShowAboutModal(true);
    }
  };

  // Handle image change for blog section
  const handleBlogImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      setBlogImages(files);

      const previews: string[] = [];
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          previews.push(reader.result as string);
          if (previews.length === files.length) {
            setBlogPreviewImages(previews);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  // Handle image change for news section
  const handleNewsImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      setNewsImages(files);

      const previews: string[] = [];
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          previews.push(reader.result as string);
          if (previews.length === files.length) {
            setNewsPreviewImages(previews);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  // Blog CRUD operations
  const handleAddOrUpdateBlog = async () => {
    try {
      setIsLoading(true);
      setError(null);
      setSuccess(null);

      if (!blogTitle || !blogContent) {
        setError("Title and content are required");
        setIsLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("title", blogTitle);
      formData.append("content", blogContent);
      formData.append("author", "Admin");
      formData.append("tags", blogTags);
      formData.append("type", "blog"); // Add type parameter

      blogImages.forEach((image) => {
        formData.append("images", image);
      });

      if (selectedBlog?._id) {
        // Update existing blog
        if (selectedBlog.imageKeys) {
          selectedBlog.imageKeys.forEach((key) => {
            formData.append("existingImageKeys", key);
          });
        }
        await updateBlog(selectedBlog._id, formData);
        setSuccess("Blog updated successfully");
      } else {
        // Create new blog
        await createBlog(formData);
        setSuccess("Blog created successfully");
      }

      await fetchBlogs();
      setShowBlogModal(false);
      resetBlogForm();
    } catch (error: any) {
      console.error("Failed to save blog:", error);
      setError(error.response?.data?.message || "Failed to save blog");
    } finally {
      setIsLoading(false);
    }
  };

  // News CRUD operations
  const handleAddOrUpdateNews = async () => {
    try {
      setIsLoading(true);
      setError(null);
      setSuccess(null);

      if (!newsTitle || !newsContent) {
        setError("Title and content are required");
        setIsLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("title", newsTitle);
      formData.append("content", newsContent);
      formData.append("author", "Admin");
      formData.append("tags", newsTags);
      formData.append("type", "news"); // Add type parameter

      newsImages.forEach((image) => {
        formData.append("images", image);
      });

      if (selectedNews?._id) {
        // Update existing news
        if (selectedNews.imageKeys) {
          selectedNews.imageKeys.forEach((key) => {
            formData.append("existingImageKeys", key);
          });
        }
        await updateBlog(selectedNews._id, formData);
        setSuccess("News updated successfully");
      } else {
        // Create new news
        await createBlog(formData);
        setSuccess("News created successfully");
      }

      await fetchNews();
      setShowNewsModal(false);
      resetNewsForm();
    } catch (error: any) {
      console.error("Failed to save news:", error);
      setError(error.response?.data?.message || "Failed to save news");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteBlog = async () => {
    try {
      if (!selectedBlog?._id) return;

      setIsLoading(true);
      setError(null);
      await deleteBlog(selectedBlog._id);
      setSuccess("Blog deleted successfully");
      setShowDeleteBlogModal(false);
      setSelectedBlog(null);
      await fetchBlogs();
    } catch (error) {
      console.error("Failed to delete blog:", error);
      setError("Failed to delete blog");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteNews = async () => {
    try {
      if (!selectedNews?._id) return;

      setIsLoading(true);
      setError(null);
      await deleteBlog(selectedNews._id);
      setSuccess("News deleted successfully");
      setShowDeleteNewsModal(false);
      setSelectedNews(null);
      await fetchNews();
    } catch (error) {
      console.error("Failed to delete news:", error);
      setError("Failed to delete news");
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewBlog = async (id: string) => {
    try {
      setIsLoading(true);
      const blog = await getBlogById(id);
      setSelectedBlog(blog);
    } catch (error) {
      console.error("Failed to fetch blog:", error);
      setError("Failed to load blog details");
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewNews = async (id: string) => {
    try {
      setIsLoading(true);
      const newsItem = await getBlogById(id);
      setSelectedNews(newsItem);
    } catch (error) {
      console.error("Failed to fetch news:", error);
      setError("Failed to load news details");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditBlog = (blog: Blog) => {
    setSelectedBlog(blog);
    setBlogTitle(blog.title);
    setBlogContent(blog.content);
    setBlogTags(blog.tags.join(", "));
    setBlogPreviewImages([]);
    setShowBlogModal(true);
  };

  const handleEditNews = (newsItem: Blog) => {
    setSelectedNews(newsItem);
    setNewsTitle(newsItem.title);
    setNewsContent(newsItem.content);
    setNewsTags(newsItem.tags.join(", "));
    setNewsPreviewImages([]);
    setShowNewsModal(true);
  };

  // Form resets
  const resetBlogForm = () => {
    setBlogTitle("");
    setBlogContent("");
    setBlogTags("");
    setBlogImages([]);
    setBlogPreviewImages([]);
    setSelectedBlog(null);
  };

  const resetNewsForm = () => {
    setNewsTitle("");
    setNewsContent("");
    setNewsTags("");
    setNewsImages([]);
    setNewsPreviewImages([]);
    setSelectedNews(null);
  };

  // Initialize data
  useEffect(() => {
    fetchAbout();
    fetchBlogs();
    fetchNews();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="About" pageTitle="Settings" />

          {/* Success/Error Alerts */}
          {error && (
            <Alert variant="danger" onClose={() => setError(null)} dismissible>
              {error}
            </Alert>
          )}
          {success && (
            <Alert
              variant="success"
              onClose={() => setSuccess(null)}
              dismissible
            >
              {success}
            </Alert>
          )}

          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">About Section</h5>
                <div>
                  {about && (
                    <Button
                      variant="danger"
                      onClick={() => setShowDeleteAboutModal(true)}
                      className="me-2"
                      disabled={isLoading}
                    >
                      Delete
                    </Button>
                  )}
                  <Button
                    variant={about ? "primary" : "success"}
                    onClick={
                      about ? handleEditClick : () => setShowAboutModal(true)
                    }
                    disabled={isLoading}
                  >
                    {about ? "Edit About" : "Add About"}
                  </Button>
                </div>
              </div>

              <Card className="mb-4">
                <Card.Body>
                  {isLoading && !about ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : about ? (
                    <div>
                      <div className="mb-4">
                        <h5>{about.title}</h5>
                        <p className="text-muted">
                          Last updated:{" "}
                          {new Date(about.updatedAt || "").toLocaleString()}
                        </p>
                        <p>{about.description}</p>
                        {about.mission && (
                          <div className="mb-3">
                            <h6>Mission</h6>
                            <p>{about.mission}</p>
                          </div>
                        )}
                        {about.vision && (
                          <div className="mb-3">
                            <h6>Vision</h6>
                            <p>{about.vision}</p>
                          </div>
                        )}
                      </div>
                      {about.imageUrls && about.imageUrls.length > 0 && (
                        <div>
                          <h6>Images</h6>
                          <div className="d-flex flex-wrap gap-3">
                            {about.imageUrls.map((url, index) => (
                              <div key={index} className="position-relative">
                                <img
                                  src={url}
                                  alt={`About ${index + 1}`}
                                  style={{
                                    width: "150px",
                                    height: "150px",
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <p>
                        No about section found. Click "Add About" to create one.
                      </p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Blog Posts</h5>
                <Button
                  variant="success"
                  onClick={() => {
                    resetBlogForm();
                    setShowBlogModal(true);
                  }}
                  disabled={isLoading}
                >
                  Add Blog Post
                </Button>
              </div>

              {isLoading && blogs.length === 0 ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : blogs.length > 0 ? (
                <Row>
                  {blogs.map((blog) => (
                    <Col key={blog._id} md={6} lg={4} className="mb-4">
                      <Card>
                        {blog.imageUrls?.length > 0 && (
                          <Card.Img
                            variant="top"
                            src={blog.imageUrls[0]}
                            style={{
                              height: "200px",
                              objectFit: "cover",
                            }}
                          />
                        )}
                        <Card.Body>
                          <Card.Title>{blog.title}</Card.Title>
                          <Card.Text className="text-muted small">
                            {new Date(blog.createdAt).toLocaleDateString()} •{" "}
                            {blog.author}
                          </Card.Text>
                          <Card.Text className="text-truncate">
                            {blog.content.substring(0, 100)}...
                          </Card.Text>
                          <div className="d-flex justify-content-between">
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleViewBlog(blog._id)}
                            >
                              View
                            </Button>
                            <div>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                className="me-2"
                                onClick={() => handleEditBlog(blog)}
                              >
                                Edit
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => {
                                  setSelectedBlog(blog);
                                  setShowDeleteBlogModal(true);
                                }}
                              >
                                Delete
                              </Button>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              ) : (
                <Card>
                  <Card.Body className="text-center py-4">
                    <p>
                      No blog posts found. Click "Add Blog Post" to create one.
                    </p>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">News Posts</h5>
                <Button
                  variant="success"
                  onClick={() => {
                    resetNewsForm();
                    setShowNewsModal(true);
                  }}
                  disabled={isLoading}
                >
                  Add News Post
                </Button>
              </div>

              {isLoading && news.length === 0 ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : news.length > 0 ? (
                <Row>
                  {news.map((newsItem) => (
                    <Col key={newsItem._id} md={6} lg={4} className="mb-4">
                      <Card>
                        {newsItem.imageUrls?.length > 0 && (
                          <Card.Img
                            variant="top"
                            src={newsItem.imageUrls[0]}
                            style={{
                              height: "200px",
                              objectFit: "cover",
                            }}
                          />
                        )}
                        <Card.Body>
                          <Card.Title>{newsItem.title}</Card.Title>
                          <Card.Text className="text-muted small">
                            {new Date(newsItem.createdAt).toLocaleDateString()}{" "}
                            • {newsItem.author}
                          </Card.Text>
                          <Card.Text className="text-truncate">
                            {newsItem.content.substring(0, 100)}...
                          </Card.Text>
                          <div className="d-flex justify-content-between">
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleViewNews(newsItem._id)}
                            >
                              View
                            </Button>
                            <div>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                className="me-2"
                                onClick={() => handleEditNews(newsItem)}
                              >
                                Edit
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => {
                                  setSelectedNews(newsItem);
                                  setShowDeleteNewsModal(true);
                                }}
                              >
                                Delete
                              </Button>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              ) : (
                <Card>
                  <Card.Body className="text-center py-4">
                    <p>
                      No news posts found. Click "Add News Post" to create one.
                    </p>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </Container>

        {/* About Add/Edit Modal */}
        <Modal
          show={showAboutModal}
          onHide={() => setShowAboutModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isEditMode ? "Edit About Section" : "Add About Section"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="aboutTitle" className="mb-3">
                <Form.Label>Title*</Form.Label>
                <Form.Control
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter title"
                  required
                />
              </Form.Group>
              <Form.Group controlId="aboutDescription" className="mb-3">
                <Form.Label>Description*</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter description"
                  required
                />
              </Form.Group>
              <Form.Group controlId="aboutMission" className="mb-3">
                <Form.Label>Mission</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={mission}
                  onChange={(e) => setMission(e.target.value)}
                  placeholder="Enter mission statement"
                />
              </Form.Group>
              <Form.Group controlId="aboutVision" className="mb-3">
                <Form.Label>Vision</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={vision}
                  onChange={(e) => setVision(e.target.value)}
                  placeholder="Enter vision statement"
                />
              </Form.Group>
              <Form.Group controlId="aboutImages" className="mb-3">
                <Form.Label>Images</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  multiple
                />
                <Form.Text className="text-muted">
                  You can upload multiple images (JPEG, PNG)
                </Form.Text>

                {/* Existing images section - only shown in edit mode */}
                {isEditMode &&
                  about?.imageUrls &&
                  about.imageUrls.length > 0 && (
                    <div className="mt-3">
                      <h6>
                        Existing Images{" "}
                        <Badge bg="info">{about.imageUrls.length}</Badge>
                      </h6>
                      <div className="d-flex flex-wrap gap-2 mb-3">
                        {about.imageUrls.map((url, index) => (
                          <div
                            key={`existing-${index}`}
                            className="position-relative"
                          >
                            <img
                              src={url}
                              alt={`Existing ${index + 1}`}
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* New images section */}
                <div className="mt-3">
                  <h6>
                    New Images{" "}
                    {previewImages.length > 0 && (
                      <Badge bg="success">{previewImages.length}</Badge>
                    )}
                  </h6>
                  {previewImages.length > 0 ? (
                    <div className="d-flex flex-wrap gap-2">
                      {previewImages.map((preview, index) => (
                        <div key={`new-${index}`} className="position-relative">
                          <img
                            src={preview}
                            alt={`Preview ${index + 1}`}
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-muted">
                      {isEditMode
                        ? "No new images added yet"
                        : "No images selected yet"}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowAboutModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleAddOrUpdateAbout}
              disabled={isLoading || !title || !description}
            >
              {isLoading
                ? isEditMode
                  ? "Updating..."
                  : "Creating..."
                : isEditMode
                ? "Update"
                : "Create"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* About Delete Confirmation Modal */}
        <Modal
          show={showDeleteAboutModal}
          onHide={() => setShowDeleteAboutModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this about section? This action
            cannot be undone.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteAboutModal(false)}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteAbout}
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Delete"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Blog Add/Edit Modal */}
        <Modal
          show={showBlogModal}
          onHide={() => setShowBlogModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedBlog ? "Edit Blog Post" : "Add Blog Post"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="blogTitle" className="mb-3">
                <Form.Label>Title*</Form.Label>
                <Form.Control
                  type="text"
                  value={blogTitle}
                  onChange={(e) => setBlogTitle(e.target.value)}
                  placeholder="Enter title"
                  required
                />
              </Form.Group>
              <Form.Group controlId="blogContent" className="mb-3">
                <Form.Label>Content*</Form.Label>
                <ReactQuill
                  theme="snow"
                  value={blogContent}
                  onChange={setBlogContent}
                  modules={modules}
                  formats={formats}
                  placeholder="Write your blog content here..."
                  style={{ height: "300px", marginBottom: "50px" }}
                />
              </Form.Group>
              <Form.Group controlId="blogTags" className="mb-3">
                <Form.Label>Tags (comma separated)</Form.Label>
                <Form.Control
                  type="text"
                  value={blogTags}
                  onChange={(e) => setBlogTags(e.target.value)}
                  placeholder="tag1, tag2, tag3"
                />
              </Form.Group>
              <Form.Group controlId="blogImages" className="mb-3">
                <Form.Label>Images</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleBlogImageChange}
                  multiple
                />
                <Form.Text className="text-muted">
                  You can upload multiple images (JPEG, PNG)
                </Form.Text>

                {selectedBlog?.imageUrls &&
                  selectedBlog.imageUrls.length > 0 && (
                    <div className="mt-3">
                      <h6>
                        Existing Images{" "}
                        <Badge bg="info">{selectedBlog.imageUrls.length}</Badge>
                      </h6>
                      <div className="d-flex flex-wrap gap-2 mb-3">
                        {selectedBlog.imageUrls.map((url, index) => (
                          <div
                            key={`existing-blog-${index}`}
                            className="position-relative"
                          >
                            <img
                              src={url}
                              alt={`Existing ${index + 1}`}
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                <div className="mt-3">
                  <h6>
                    New Images{" "}
                    {blogPreviewImages.length > 0 && (
                      <Badge bg="success">{blogPreviewImages.length}</Badge>
                    )}
                  </h6>
                  {blogPreviewImages.length > 0 ? (
                    <div className="d-flex flex-wrap gap-2">
                      {blogPreviewImages.map((preview, index) => (
                        <div
                          key={`new-blog-${index}`}
                          className="position-relative"
                        >
                          <img
                            src={preview}
                            alt={`Preview ${index + 1}`}
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-muted">
                      {selectedBlog
                        ? "No new images added yet"
                        : "No images selected yet"}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowBlogModal(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleAddOrUpdateBlog}
              disabled={isLoading || !blogTitle || !blogContent}
            >
              {isLoading
                ? selectedBlog
                  ? "Updating..."
                  : "Creating..."
                : selectedBlog
                ? "Update"
                : "Create"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* News Add/Edit Modal */}
        <Modal
          show={showNewsModal}
          onHide={() => setShowNewsModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedNews ? "Edit News Post" : "Add News Post"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="newsTitle" className="mb-3">
                <Form.Label>Title*</Form.Label>
                <Form.Control
                  type="text"
                  value={newsTitle}
                  onChange={(e) => setNewsTitle(e.target.value)}
                  placeholder="Enter title"
                  required
                />
              </Form.Group>
              <Form.Group controlId="newsContent" className="mb-3">
                <Form.Label>Content*</Form.Label>
                <ReactQuill
                  theme="snow"
                  value={newsContent}
                  onChange={setNewsContent}
                  modules={modules}
                  formats={formats}
                  placeholder="Write your news content here..."
                  style={{ height: "300px", marginBottom: "50px" }}
                />
              </Form.Group>
              <Form.Group controlId="newsTags" className="mb-3">
                <Form.Label>Tags (comma separated)</Form.Label>
                <Form.Control
                  type="text"
                  value={newsTags}
                  onChange={(e) => setNewsTags(e.target.value)}
                  placeholder="tag1, tag2, tag3"
                />
              </Form.Group>
              <Form.Group controlId="newsImages" className="mb-3">
                <Form.Label>Images</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleNewsImageChange}
                  multiple
                />
                <Form.Text className="text-muted">
                  You can upload multiple images (JPEG, PNG)
                </Form.Text>

                {selectedNews?.imageUrls &&
                  selectedNews.imageUrls.length > 0 && (
                    <div className="mt-3">
                      <h6>
                        Existing Images{" "}
                        <Badge bg="info">{selectedNews.imageUrls.length}</Badge>
                      </h6>
                      <div className="d-flex flex-wrap gap-2 mb-3">
                        {selectedNews.imageUrls.map((url, index) => (
                          <div
                            key={`existing-news-${index}`}
                            className="position-relative"
                          >
                            <img
                              src={url}
                              alt={`Existing ${index + 1}`}
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                <div className="mt-3">
                  <h6>
                    New Images{" "}
                    {newsPreviewImages.length > 0 && (
                      <Badge bg="success">{newsPreviewImages.length}</Badge>
                    )}
                  </h6>
                  {newsPreviewImages.length > 0 ? (
                    <div className="d-flex flex-wrap gap-2">
                      {newsPreviewImages.map((preview, index) => (
                        <div
                          key={`new-news-${index}`}
                          className="position-relative"
                        >
                          <img
                            src={preview}
                            alt={`Preview ${index + 1}`}
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-muted">
                      {selectedNews
                        ? "No new images added yet"
                        : "No images selected yet"}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowNewsModal(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleAddOrUpdateNews}
              disabled={isLoading || !newsTitle || !newsContent}
            >
              {isLoading
                ? selectedNews
                  ? "Updating..."
                  : "Creating..."
                : selectedNews
                ? "Update"
                : "Create"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Blog View Modal */}
        <Modal
          show={!!selectedBlog && !showBlogModal && !showDeleteBlogModal}
          onHide={() => setSelectedBlog(null)}
          size="lg"
        >
          {selectedBlog && (
            <>
              <Modal.Header closeButton>
                <Modal.Title>{selectedBlog.title}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3 text-muted">
                  <small>
                    Posted on{" "}
                    {new Date(selectedBlog.createdAt).toLocaleDateString()} by{" "}
                    {selectedBlog.author}
                  </small>
                </div>
                {selectedBlog.tags.length > 0 && (
                  <div className="mb-3">
                    {selectedBlog.tags.map((tag, index) => (
                      <Badge key={index} bg="secondary" className="me-2">
                        {tag}
                      </Badge>
                    ))}
                  </div>
                )}
                <div className="mb-4">
                  <p style={{ whiteSpace: "pre-line" }}>
                    {selectedBlog.content}
                  </p>
                </div>
                {selectedBlog.imageUrls &&
                  selectedBlog.imageUrls.length > 0 && (
                    <div>
                      <h6>Images</h6>
                      <div className="d-flex flex-wrap gap-3">
                        {selectedBlog.imageUrls.map((url, index) => (
                          <div key={index} className="position-relative">
                            <img
                              src={url}
                              alt={`Blog ${index + 1}`}
                              style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setSelectedBlog(null)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </>
          )}
        </Modal>

        {/* News View Modal */}
        <Modal
          show={!!selectedNews && !showNewsModal && !showDeleteNewsModal}
          onHide={() => setSelectedNews(null)}
          size="lg"
        >
          {selectedNews && (
            <>
              <Modal.Header closeButton>
                <Modal.Title>{selectedNews.title}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3 text-muted">
                  <small>
                    Posted on{" "}
                    {new Date(selectedNews.createdAt).toLocaleDateString()} by{" "}
                    {selectedNews.author}
                  </small>
                </div>
                {selectedNews.tags.length > 0 && (
                  <div className="mb-3">
                    {selectedNews.tags.map((tag, index) => (
                      <Badge key={index} bg="secondary" className="me-2">
                        {tag}
                      </Badge>
                    ))}
                  </div>
                )}
                <div className="mb-4">
                  <p style={{ whiteSpace: "pre-line" }}>
                    {selectedNews.content}
                  </p>
                </div>
                {selectedNews.imageUrls &&
                  selectedNews.imageUrls.length > 0 && (
                    <div>
                      <h6>Images</h6>
                      <div className="d-flex flex-wrap gap-3">
                        {selectedNews.imageUrls.map((url, index) => (
                          <div key={index} className="position-relative">
                            <img
                              src={url}
                              alt={`News ${index + 1}`}
                              style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setSelectedNews(null)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </>
          )}
        </Modal>

        {/* Blog Delete Confirmation Modal */}
        <Modal
          show={showDeleteBlogModal}
          onHide={() => setShowDeleteBlogModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this blog post? This action cannot
            be undone.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteBlogModal(false)}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteBlog}
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Delete"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* News Delete Confirmation Modal */}
        <Modal
          show={showDeleteNewsModal}
          onHide={() => setShowDeleteNewsModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this news post? This action cannot
            be undone.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteNewsModal(false)}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteNews}
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Delete"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default AboutBlog;
